import type {SelectOption} from 'client/TeacherDashboard/types';

import type {DueWithinFilter, SkillPathSortValue, SkillPathStatusSegment} from './types';

export const STATUS_SEGMENTS: {value: SkillPathStatusSegment; label: string}[] = [
  {value: 'open', label: 'Open'},
  {value: 'closed', label: 'Closed'},
  {value: 'scheduled', label: 'Scheduled'}
];

export const DUE_WITHIN_FILTER_OPTIONS: ReadonlyArray<SelectOption<DueWithinFilter>> = [
  {value: 'schoolYear', label: 'This school year'},
  {value: 'month', label: 'This month'},
  {value: 'week', label: 'This week'},
  {value: 'custom', label: 'Custom'}
];

export const SORT_OPTIONS: ReadonlyArray<SelectOption<SkillPathSortValue>> = [
  {value: 'dueDate', label: 'Due Date'},
  {value: 'startDate', label: 'Start Date'},
  {value: 'name', label: 'Name'}
];

/** The All Classes and class-scoped destinations for the Skill Paths view. */
export const ALL_SKILL_PATHS_PATH = '/skill-paths';
export const getClassSkillPathsPath = (classroomId: string): string =>
  `/classes/${classroomId}/skill-paths`;

/** Empty-state deep links (the designed "Adaptive Math →" / "View All Adaptive" actions). */
export const ADAPTIVE_SUBJECTS_PATH = '/subjects';

/**
 * Report deep link for a skill row: the teacher report filtered to this skill on the students
 * dimension, class-scoped when a classroom is in scope.
 * TODO(part-01 data): confirm the canonical skill-report route with the reports team.
 */
export const getSkillReportPath = (
  actorTeacherId: string,
  skillId: string,
  classroomId?: string
): string | null =>
  actorTeacherId
    ? `/reports/teachers/${actorTeacherId}${
        classroomId ? `/classrooms/${classroomId}` : ''
      }/skills/${skillId}/students`
    : null;
